import { createTracker } from '@trimble/analytics';
import { LayerListPanelAnalyticsEvent } from './layer-list-panel-analytics-events';

const eventPrefix = 'SiteViz: ';

export const layerListPanelTracker =
  createTracker<LayerListPanelAnalyticsEvent>(eventPrefix);
